import * as yup from 'yup';

export const schema = yup.object({
  email: yup.string().email('Use um e-mail válido!').required('O e-mail é obrigatório!'),
  password: yup.string().required('A senha é obrigatória!'),
  saveUser: yup.boolean(),
}).required();
